import { FC } from 'react';
import draftFilesIcon from 'images/draft-files-icon.svg';

const DraftFilesIcon: FC = (props): JSX.Element => {
  return (
    <img
      height={'18px'}
      width={'17px'}
      src={draftFilesIcon}
      alt="draft-files-icon"
    />
  );
};
export default DraftFilesIcon;
